import { Component, OnInit, Input, Output, ViewChild, ElementRef, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { OtaService } from '@myproject/components/central-ota/ota.service';
import { SharedService } from '../shared.service';
import { environment } from '@myenv/environment';
import { enMessage } from '../en-us-message';
import { ButtonDropdownOption } from '../button-dropdown/button-dropdown.component';

@Component({
    selector: 'app-ota-file-upload-modal',
    templateUrl: './ota-file-upload-modal.component.html',
    styleUrls: ['./ota-file-upload-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtaFileUploadModalComponent implements OnInit, OnChanges {

  @Input() showModal!: boolean;
  @Input() hideModal!: boolean;
  @Input() editModal!: boolean;
  @Output() uploadSuccess = new EventEmitter();
  @ViewChild('closeModal') btnClose!: ElementRef;
  @ViewChild('fileName0') dotaFileName!: ElementRef;
  @ViewChild('eotaFileName0') eotaFileName!: ElementRef;
  public EOTA_Enabled = false;
  EOTA_Authorities: Record<string, any> = {
    authorities: [] as any[]
  };
  responseMessage: any = {};
  fileUploadType: string | null = null;
  deviceFileTypes = [
    { key: 'CFG', displayName: 'Configurations', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'FW', displayName: 'Firmwares', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'PACKAGE', displayName: 'Package', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    { key: 'SDK', displayName: 'SDK', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
  ];
  ecuFileTypes = [
    { key: 'EOTA', displayName: 'ECU OTA', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
    // { key: 'SDK', displayName: 'SDK', fileExtension: '.gz,.tlv,.bin,.enc,.en' },
  ];
  dataSource = [
    { a: '', b: '' }
  ];
  columns = [{
    otaType: 'CFG',
    newFolderName: '',
    DescrName:'',
    fileName: '',
    fileExtension: '.gz,.tlv,.bin,.enc,.en',
    ecuGroupList: [] as any[],
    selectedEcuGroup: undefined as any,
    ecuNameList: [] as any[],
    selectedEcuName: undefined as any,
    fileVersion: undefined as any
  }];
  uploadProgress = 0;
  incrimentBy!: number;
  uploadedFile: any;
  attachedFile = false;
  formsNotValid = 0;
  validForm = true;
  disable = false;
  otaeditfile:boolean =false;
  type!: string;
  isOtaPartner = false;

  constructor(
    private otaService: OtaService,
    private sharedService: SharedService,
  ) { }

  get deviceFileTypeOptions(): ButtonDropdownOption[] {
    return this.deviceFileTypes.map((item) => ({
      value: item.key,
      label: item.displayName,
    }));
  }

  get ecuFileTypeOptions(): ButtonDropdownOption[] {
    return this.ecuFileTypes.map((item) => ({
      value: item.key,
      label: item.displayName,
    }));
  }

  onDeviceFileTypeSelect(value: string | number, index: number): void {
    this.columns[index].otaType = String(value);
    this.changeExtension(index);
  }

  onEcuFileTypeSelect(value: string | number, index: number): void {
    this.columns[index].otaType = String(value);
    this.changeExtension(index);
  }

  getEcuGroupOptions(index: number): ButtonDropdownOption[] {
    return (this.columns[index]?.ecuGroupList || []).map((group) => ({
      value: group,
      label: group,
    }));
  }

  getEcuNameOptions(index: number): ButtonDropdownOption[] {
    return (this.columns[index]?.ecuNameList || []).map((name) => ({
      value: name,
      label: name,
    }));
  }

  onEcuGroupSelect(value: string | number, index: number): void {
    this.columns[index].selectedEcuGroup = String(value);
    this.getEcuNames(index);
  }

  onEcuNameSelect(value: string | number, index: number): void {
    this.columns[index].selectedEcuName = String(value);
  }

  getSelectedFileLabel(index: number): string {
    const file = this.columns[index]?.fileName as string | File | undefined | null;
    if (!file) {
      return 'No file chosen';
    }
    return typeof file === 'string' ? file : file.name;
  }

  ngOnInit() {
    const pm = localStorage.getItem('permissionModules');
    const modules = JSON.parse(localStorage.getItem('accessRoleModules') || '[]');
    this.EOTA_Authorities = modules.find((module: any) => module.name === 'EOTA');
    this.type = JSON.parse(localStorage.getItem('currentUser') || '{}').productType.toLowerCase();
    this.isOtaPartner = this.sharedService.isOtaPartner();
  }

  ngOnChanges(changes: any) {
    // Show Modal
    if (changes.showModal && changes.showModal.previousValue !== undefined) {
      if (changes.showModal.previousValue !== changes.showModal.currentValue) {
        const eota = this.EOTA_Authorities;
        if (!(eota && eota.authorities && eota.authorities.includes('WRITE'))) {
          this.onTypeSelect('device');
        } else {
          this.fileUploadType = null;
        }
        document.getElementById('uploadFileModalBtn')!.click();
        this.otaeditfile = false;
      }
    }
    // Hide Modal
    if (changes.hideModal && changes.hideModal.previousValue !== undefined) {
      if (changes.hideModal.previousValue !== changes.hideModal.currentValue) {
        document.getElementById('closeModal')!.click();
        this.otaeditfile = false;
      }
    }
    // Edit Modal
    if(changes.editModal ){
      if(changes.editModal.currentValue !== undefined){
        if (!this.EOTA_Enabled) {
          this.onTypeSelect('device');
        } else {
          this.fileUploadType = null;
        }
        this.fillFiledetails(changes.editModal.currentValue);
        this.otaeditfile = true;
        this.validForm = true;
        document.getElementById('uploadFileModalBtn')!.click();
      }
    }
  }

  onTypeSelect(type: string | null) {
    this.fileUploadType = type;
    this.addNewFile(0);
    let element;
    if (type === 'device') element = this.dotaFileName;
    else if (type === 'ecu') element = this.eotaFileName;
    this.autofocus(element);
  }

  addNewFile(index: number) {
    this.uploadProgress = 0;
    this.incrimentBy = 0;
    this.dataSource = [
      { a: '', b: '' }
    ];
    this.columns = [{
      otaType: this.fileUploadType === 'device' ? (this.isOtaPartner ? 'FW' : 'CFG') : 'EOTA',
      newFolderName: '',
      DescrName:'',
      fileName: '',
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [],
      selectedEcuGroup: '',
      ecuNameList: [],
      selectedEcuName: '',
      fileVersion: ''
    }];
    if (this.fileUploadType === 'ecu') { this.getEcuGroups(index); }
  }

  addRow() {
    this.dataSource.push({ a: '', b: '' });
    let columnObject = {
      otaType: this.fileUploadType === 'device' ? (this.isOtaPartner ? 'FW' : 'CFG') : 'EOTA',
      newFolderName: '',
      DescrName:'',
      fileName: '',
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [] as any[],
      selectedEcuGroup: '',
      ecuNameList: [] as any[],
      selectedEcuName: '',
      fileVersion: ''
    };
    this.columns.push(columnObject);
    if (this.fileUploadType === 'ecu') { this.getEcuGroups(this.columns.length - 1); }
  }

  /* To delete the row with select box and input box
      on clicking times(X) icon
  */
  deleteRow(index: number) {
    this.dataSource.splice(index, 1);
    this.columns.splice(index, 1);
  }

  changeExtension(index: number) {
    let types;
    if (this.fileUploadType === 'device') {
      types = this.deviceFileTypes;
    } else {
      types = this.ecuFileTypes;
    }
    types.map(item => {
      if (item.key === this.columns[index].otaType) {
        this.columns[index].fileExtension = item.fileExtension;
      }
    });
  }

  getEcuGroups(index: number) {
    this.otaService.getEcuGroups().subscribe({
      next: res => {
        this.columns[index].ecuGroupList = res;
        if (res.length) {
          this.columns[index].selectedEcuGroup = res[0];
          this.getEcuNames(index);
        } else {
          this.columns[index].selectedEcuGroup = '';
        }
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  getEcuNames(index: number) {
    this.otaService.getEcuNames(this.columns[index].selectedEcuGroup).subscribe({
      next: res => {
        this.columns[index].ecuNameList = res;
        if (res.length) {
          this.columns[index].selectedEcuName = res[0];
        } else {
          this.columns[index].selectedEcuName = '';
        }
      },
      error: error => {
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  // To upload a file
  getUploadedFile(file: any, i: number) {
    this.columns[i]['fileName'] = file.files[0];
    if(this.columns[i]['newFolderName'].length ==0){
      this.columns[i]['newFolderName'] =  file.files[0].name;
    }
    if (file.value) {
      this.uploadedFile = file;
      this.validForm = true;
    } else {
      this.formsNotValid = this.formsNotValid + 1;
      this.validForm = false;
    }
  }

  uploadMultiFiles(isValid: boolean | null, form: any) {
    if (isValid) {
      this.incrimentBy = 0;
      this.incrimentBy = 100 / this.columns.length;
      for (let i = 0; i < this.columns.length; i++) {
        if (!this.columns[i]['fileName']) {
          this.formsNotValid = this.formsNotValid + 1;
          this.attachedFile = true;
        } else {
          this.formsNotValid = 0;
          this.attachedFile = false;
        }
      }
      if (this.formsNotValid == 0 && isValid) {
        for (let i = 0; i < this.columns.length; i++) {
          if(this.otaeditfile) {
            this.editfileConfigXL(isValid, this.columns[0], form, 0)
          } else {
            this.uploadConfigXL(isValid, this.columns[i], form, i);
          }
        }
      }
    }
  }

  // To add a new file
  uploadConfigXL(isValid: boolean, column: any, form: any, index: number) {
    if (isValid) {
      // if (this.searchModel.userIds) {
      //   this.searchModel.userIds = this.searchModel.userIds.toString();
      // }
      this.disable = true;
      if (!this.validForm) {
        this.attachedFile = true;
        this.disable = false;
      } else {
        this.attachedFile = false;
        let file = column.fileName;
        if (file) {
          let formData = new FormData();
          formData.append('file', file);
          formData.append('description',column.DescrName)

          let service = this.type === "bitbrew" ? this.otaService.uploadXL(
            formData, column.newFolderName, column.otaType, column.fileVersion, column.selectedEcuGroup, column.selectedEcuName
          ) : this.otaService.uploadV2XL(
            formData, column.newFolderName, column.otaType, column.fileVersion, column.selectedEcuGroup, column.selectedEcuName, this.type
          );
          
          service.subscribe(res => {
            this.responseMessage = { success: true, message: enMessage.successFile };
            this.sharedService.setResponseMessage(this.responseMessage);
            this.btnClose.nativeElement.click();
            this.uploadSuccess.next(undefined);
            this.disable = false;
            this.uploadProgress += this.incrimentBy;
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
          }, error => {
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
            // if (error.errorCode == 'OTA002') {
            //   this.responseMessage = { success: false, message: `File name already exists with ${error.args[0]}` };
            //   this.sharedService.setResponseMessage(this.responseMessage);
            // } else {
              this.sharedService.getErrorMsg(error);
            // }
            this.disable = false;
          });
        } else {
          this.responseMessage = { success: false, message: enMessage.errorNoChooseCsvFile }
          this.sharedService.setResponseMessage(this.responseMessage);
          this.disable = false;
        }
      }
    } else {
      this.attachedFile = true;
    }
  }

  closeModal(f?: any) {
    this.fileUploadType = null;
    this.attachedFile = false;
    document.getElementById('close-modal')!.click();
    if (f) {
      f.resetForm();
    }
  }

  autofocus(element: any) {
    if (this.fileUploadType === null) return;
    setTimeout(() => {
      const inputElem = <HTMLInputElement>element.nativeElement;
      inputElem.select();
    }, 200);
  }

  fillFiledetails(row: any){
    this.dataSource = [
      { a: '', b: '' }
    ];
    let columnObject = {
      otaType: row.fileType,
      newFolderName: row.uploadedFileName,
      DescrName: row.description,
      fileName: row.fileName,
      fileExtension: '.gz,.tlv,.bin,.enc,.en',
      ecuGroupList: [] as any[],
      selectedEcuGroup: '',
      ecuNameList: [] as any[],
      selectedEcuName: '',
      fileId:row.fileId,
      fileVersion: row.fileVersion
    };
    this.attachedFile = true;
    this.columns=[];
    this.columns.push(columnObject);
  }

  cancelModal(f?: any){
    document.getElementById('close-modal')!.click();
    this.uploadSuccess.next(undefined);
    if (f) {
      f.resetForm();
    }
  }

  onKeyPress(val: any){
    var value = val.target.value;
    if(value.length>=100){
      this.responseMessage = { success: false, enMessage: `Description can not be more than 100 Characters.` };
      this.sharedService.setResponseMessage(this.responseMessage);
    }
  }

  editfileConfigXL(isValid: boolean, column: any, form: any, index: number) {
    if (isValid) {
      this.disable = true;
      if (!this.validForm) {
        this.attachedFile = true;
        this.disable = false;
      } else {
        this.attachedFile = false;
        if (column.fileId) {
          let service = this.otaService;
          service.editfile(
            column.DescrName,column.fileId).subscribe(res => {
            this.responseMessage = { success: true, message: "Description Updated successfully." };
            this.sharedService.setResponseMessage(this.responseMessage);
            this.btnClose.nativeElement.click();
            this.uploadSuccess.next(undefined);
            this.disable = false;
            this.uploadProgress += this.incrimentBy;
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
          }, error => {
            if (index == this.columns.length - 1) {
              this.btnClose.nativeElement.click();
              form.resetForm();
            }
              this.sharedService.getErrorMsg(error);
            this.disable = false;
          });
        } else {
          this.responseMessage = { success: false, message: enMessage.errorNoChooseCsvFile }
          this.sharedService.setResponseMessage(this.responseMessage);
          this.disable = false;
        }
      }
    } else {
      this.attachedFile = true;
    }
  }

  closeOTAFileUploadModal() {
    this.fileUploadType = null;
    this.attachedFile = false;
    document.getElementById('close-modal')!.click();
  }

}
